import { Box } from "@material-ui/core";
import { SPView } from "components/common/MediaQuery";
import React from "react";

import { StreamingAnnouncement } from "./StreamingAnnouncement";
import { StreamingEventDetailV2 } from "./StreamingEventDetailV2";
import { EventVideoListContainerV2 } from "./StreamingEventDetailVideoListV2";
import { StreamingEventNavigation } from "./StreamingEventNavigation";
import { StreamingOptions } from "./StreamingOptions";

import type { StreamingType } from "@spwn/types";
import type { FC } from "react";
import type { EventInfo } from "utility";

export type Props = {
  eventInfo: EventInfo;
  currentVideoId: string;
  selectVideoId: string;
  streamingType: StreamingType;
  clickCount: number;
  isAdmin: boolean;
  isDarkModeEnabled: boolean;
  isOpenAnnouncement: boolean;
  isEditingAnnouncement: boolean;
  streamingAnnouncement: string;
  isLiveCommerceEnabled: boolean;
  setClickCount: (num: number) => void;
  setWatchVideo: (vid: string) => void;
  setIsEditingAnnouncement: (isEditing: boolean) => void;
  setStreamingAnnouncement: (announcement: string) => void;
  handleToggleAnnouncement: () => void;
  handleClickCommentNavigation: () => void;
  handleClickGoodsNavigation: () => void;
};

const StreamingSummaryColumn: FC<Props> = ({
  eventInfo,
  currentVideoId,
  selectVideoId,
  streamingType,
  clickCount,
  isAdmin,
  isDarkModeEnabled,
  isOpenAnnouncement,
  isEditingAnnouncement,
  streamingAnnouncement,
  isLiveCommerceEnabled,
  setClickCount,
  setWatchVideo,
  setIsEditingAnnouncement,
  setStreamingAnnouncement,
  handleToggleAnnouncement,
  handleClickCommentNavigation,
  handleClickGoodsNavigation,
}) => {
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      gridGap={"16px"}
      padding={"16px"}
    >
      <StreamingOptions
        showAnnouncement={isAdmin || streamingAnnouncement !== ""}
        handleToggleAnnouncement={handleToggleAnnouncement}
      />

      <SPView>
        <StreamingAnnouncement
          eventId={eventInfo.eventId}
          currentVideoId={currentVideoId}
          streamingType={streamingType}
          isDarkModeEnabled={isDarkModeEnabled}
          isAdmin={isAdmin}
          isOpenAnnouncement={isOpenAnnouncement}
          isEditingAnnouncement={isEditingAnnouncement}
          setIsEditingAnnouncement={setIsEditingAnnouncement}
          streamingAnnouncement={streamingAnnouncement}
          setStreamingAnnouncement={setStreamingAnnouncement}
        />
      </SPView>

      <StreamingEventDetailV2
        event={eventInfo}
        currentVid={currentVideoId}
        selectVideoId={selectVideoId}
        clickCount={clickCount}
        setWatchVideo={setWatchVideo}
        setClickCount={setClickCount}
      />

      <StreamingEventNavigation
        isDarkModeEnabled={isDarkModeEnabled}
        isLiveCommerceEnabled={isLiveCommerceEnabled}
        showCommentNavigation={!eventInfo.isHiddenStreamingComment}
        handleClickCommentNavigation={handleClickCommentNavigation}
        handleClickGoodsNavigation={handleClickGoodsNavigation}
      />

      <EventVideoListContainerV2
        isDarkModeEnabled={isDarkModeEnabled}
        event={eventInfo}
        currentVid={currentVideoId}
        selectVideoId={selectVideoId}
        setWatchVideo={setWatchVideo}
      />
    </Box>
  );
};

export default StreamingSummaryColumn;
